import React, { useState } from 'react'
import { Header, Button, Paragraph, ErrorMark, MortgageRegulationContacts } from "../../../components/RegularComponents";
import TopNavigationBar from "../../TopNavigationBar";
import * as CONST from "../../../app/constants";
import { push } from 'connected-react-router';
import { useDispatch, useSelector } from 'react-redux';
import { agencyApplicationSelector } from "../../../redux/selector/agencyApplicationSelector";
import { 
    applicationTypeFromLicenceSubType,
    isMortgageTypeApplication
 } from '../../../redux/slice/applicationsUtils';
import { setMortgageCacheProperty } from '../../../redux/slice/primaryAgencyApplicationSlice';

export const RenewalComplianceOfficerQualification = (props) => {

    const { agencyApplication }  = useSelector(
        agencyApplicationSelector
    );
    const { isModal = false, onEditSave = () => {} } = props;

    const [notQualified, setNotQualified] = useState(false);

    const dispatch = useDispatch();
    
    const handleContinue = () => {
        if(isModal) {
            onEditSave()
            return
        }

        dispatch(setMortgageCacheProperty({
            key: CONST.MORTGAGE_PROPERTY_KEYS.IS_CO_QUALIFICATIONS_ACCEPTED,
            value: true
        }))

        const applicationType = applicationTypeFromLicenceSubType(agencyApplication.licencingSubType)
        // console.log({applicationType})
        let nextUrl
        if(applicationType === CONST.APPLICATION_TYPE_MORTGAGE_LENDER_LICENCE) {
            nextUrl = `${CONST.ROUTE_PATH.ML_APP}${CONST.ROUTE_PATH.RENEWAL_REGULATION_ACT}`
        } else if(applicationType === CONST.APPLICATION_TYPE_MORTGAGE_ADMINISTRATOR_LICENCE) {
            nextUrl = `${CONST.ROUTE_PATH.MA_APP}${CONST.ROUTE_PATH.RENEWAL_REGULATION_ACT}`
        } else if(isMortgageTypeApplication(applicationType)) {
            nextUrl = `${CONST.ROUTE_PATH.MRA_APP}${CONST.ROUTE_PATH.RENEWAL_REGULATION_ACT}`;
        }
        dispatch(push(nextUrl));
    }

    const handleCancel = () => {
        //No futher proceed on No selection
        // Modal should close with Yes only
        // dispatch(setMortgageProperty({
        //     key: CONST.MORTGAGE_PROPERTY_KEYS,
        //     value: false
        // }))
        setNotQualified(true);
    }

    return (
        <div className={!isModal ? "container" : ""}>
            {!isModal && <TopNavigationBar {...props} />}
            
            <div className="row">
                {!isModal &&
                <div className="col-xs-12 col-lg-11">
                    <Header
                        id="mra-renewal-confirm-air-header"
                        header="Compliance Officer Qualifications"
                    />
                </div>
                }
                <div className="col-xs-12 col-lg-11 topMarginMedium">
                    <Paragraph
                        id="mra-renewal-confirm-air-text-1"
                        style={{fontWeight: "bold", fontSize: "1.2em"}}
                        text={[
                            `Please review the following requirements`,
                        ]}
                    />
                </div>
            </div>
            
            <div className={"row"}>
                <div className={"col-8"}>
                    <ol className="principalBrokerQualificationReqList">
                        <li>
                            Is the Compliance Officer <b>19 years of age or older?</b>
                        </li>
                        <li>
                            Is the Compliance Officer a <b>resident of Canada?</b>
                        </li>
                        <li>
                            The Compliance Officer is engaged in the activities of the licensee to the extent that the individual is capabale 
                            of carrying out their duties and responsibilities under the <a href={CONST.MRA_REGULATION_ACT_DOCUMENT_LINK} target="blank">Act</a> and 
                            its <a href={CONST.MRA_REGULATION_JUSTICE_LINK} target="blank"> regulations</a>.
                        </li>
                    </ol>
                </div>

                <div className={"col-8 topMarginMedium"}>
                    <b>Do you meet these requirements?</b>
                </div>
            </div>

            <div className="row topMarginMedium">
                <div className="col-lg-8">
                    <div className="col-xs-4">
                        <Button
                            className="ns-btn-yes-no btn-default"
                            buttonType={"regular_primary"}
                            text={"Yes"}
                            onClick={handleContinue}
                        />
                    </div>
                    <div className="col-xs-6">
                        <Button
                            className="ns-btn-yes-no btn-default"
                            buttonType={"regular_primary"}
                            text={"No"}
                            onClick={handleCancel}
                        />
                        {notQualified  && ErrorMark()}
                        {notQualified && (
                           <MortgageRegulationContacts message="If you do not meet the qualifications, you must assign a different 
                                Compliance Officer who meets the qualifications. To assign a different  Compliance Officer, contact Business Licensing:"
                           />
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}
